import React from 'react';
import { Link } from 'react-router-dom';

const HomePage = () => {
    return (
        <div>
            <Link to="/atlas-packer">Atlas Packer</Link>
            <br />
            <Link to="/animation-tool">Animation Tool</Link>
        </div>
    );
};

export default HomePage;
